import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [isFamilySiteOpen, setIsFamilySiteOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const familySites = [
    { name: "뉴아레오", url: "https://new.arreo.com" },
    { name: "아레오", url: "https://www.arreo.com" },
    { name: "싸다오", url: "https://www.ssadao.com" },
    { name: "네띠앙", url: "https://www.netian.com" },
  ];

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsFamilySiteOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <footer className="bg-[#2b2b2b] text-white mt-auto w-full px-12 wide:px-0">
      <div className="px-8 py-12 mx-auto md:px-0 max-w-container md:py-16">
        {/* 상단: 로고 + 링크 */}
        <div className="flex flex-col gap-8 pb-8 mb-8 border-b border-gray-700 lg:flex-row lg:justify-between lg:items-start">
          <div className="flex flex-col gap-6 items-start justify-between w-full about:flex-row about:justify-between about:items-center">
            <img src="/img/footer_logo.png" alt="하단 로고" className="h-10" />
            <nav className="flex flex-wrap gap-4 md:gap-6" aria-label="정책 링크">
              <Link
                to="/policy/privacy"
                className="text-[1.3rem] font-bold text-white transition-colors"
              >
                개인정보처리방침
              </Link>
              <Link
                to="/policy/terms"
                className="text-[1.3rem] text-gray-300 hover:text-white transition-colors"
              >
                이용약관
              </Link>
              <Link
                to="/policy/email-refusal"
                className="text-[1.3rem] text-gray-300 hover:text-white transition-colors"
              >
                이메일무단수집거부
              </Link>
              <Link
                to="/policy/sitemap"
                className="text-[1.3rem] text-gray-300 hover:text-white transition-colors"
              >
                사이트맵
              </Link>
            </nav>
          </div>
        </div>

        {/* 하단: 회사 정보 + Family Site */}
        <div className="flex gap-5 flex-col md:flex-row lg:flex-row justify-between ">
          {/* 회사 정보 */}
          <div className="space-y-4">
            <div className="flex flex-col gap-y-4 text-[1.4rem] about:flex-row about:flex-wrap about:gap-x-8 flex-col-reverse">
              <div className="flex flex-col gap-2 about:gap-4">
                <div>
                  <span className="mr-2 text-gray-400 font-bold">스탠다드네트웍스</span>
                  <span className="text-gray-200">서울시 강남구 봉은사로 18길 84 3층</span>
                </div>
                <div>
                  <span className="mr-2 text-gray-400 font-bold">대표 이메일</span>
                  <span className="text-gray-200">support@standard.kr</span>
                </div>
              </div>

              <div className="flex flex-col gap-2 about:gap-4">
                <p>
                  <span className="mr-2 text-gray-400 font-bold">대표자</span>
                  <span className="text-gray-200">이주호</span>
                </p>
                <div>
                  <span className="mr-2 text-gray-400 font-bold">메시징 서비스 문의 </span>
                  <span className="text-gray-200">015-8504-0005</span>
                </div>
                <div>
                  <span className="mr-2 text-gray-400 font-bold">문자콜센터 서비스 문의</span>
                  <span className="text-gray-200">015-8504-0006</span>
                </div>
              </div>
            </div>
          </div>

          {/* Family Site*/}
          <div className="flex items-start flex flex-col items-end gap-4">
            <div className="relative" ref={dropdownRef}>
              <button
                type="button"
                className="flex items-center gap-2 px-5 py-2.5 bg-white border border-gray-600 rounded-full justify-between min-w-[180px] text-[1.4rem] text-gray-900 font-bold hover:bg-gray-100 transition-colors"
                onClick={() => setIsFamilySiteOpen(!isFamilySiteOpen)}
              >
                Family Site
                <span
                  className={`material-icons-round text-[2rem] transition-transform ${isFamilySiteOpen ? "rotate-45" : ""}`}
                >
                  add
                </span>
              </button>

              <ul
                className={`absolute bottom-full left-0 mb-2 bg-white border rounded-xl shadow-xl overflow-hidden min-w-[180px] transition-all ${
                  isFamilySiteOpen
                    ? "opacity-100 translate-y-0 visible"
                    : "opacity-0 translate-y-2 invisible"
                }`}
              >
                {familySites.map(site => (
                  <li key={site.name}>
                    <a
                      href={site.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-5 py-3 text-[1.4rem] text-gray-700 hover:bg-gray-100"
                    >
                      {site.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <p className="text-[1.2rem] text-gray-500 about:mt-4 md:whitespace-nowrap ">
              copyright © STANDARD NETWORKS.INC. ALL RIGHTS RESERVED.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
